import { SingleCallAsync } from "./SingleCallAsync";

export class PollingListener<Data> {
  private protectedRefresh: SingleCallAsync;
  public onData?: (data: Data) => Promise<void>;

  constructor(
    public readonly getNewData: () => Promise<Data>,
    public readonly intervalInMs: number
  ) {
    this.protectedRefresh = new SingleCallAsync(async () => {
      const data = await this.getNewData();
      this.onData?.(data);
    });
  }
  refresh() {
    return this.protectedRefresh.call();
  }
  start() {
    this.refresh();
    return setInterval(() => {
      this.refresh();
    }, this.intervalInMs);
  }
  isLastCallSuccessful(): boolean {
    return this.protectedRefresh.isLastCallSuccessful;
  }
}
